import React, {FC, useEffect} from "react";
import './uploadContent.scss';
import uploadIcon from "../../../assets/icons/upload.svg";
import Uppy from '@uppy/core';
import { FileInput, useUppy,StatusBar } from '@uppy/react';
import AwsS3Multipart from '@uppy/aws-s3-multipart';
import '@uppy/core/dist/style.css';
import '@uppy/status-bar/dist/style.css';
import {FILE_UPLOAD_BASE_URL} from "../../../routes/routeConstants/apiRoutes";

interface UploadContentProps{
    handleUploadComplete: Function;
    contentType: any;
}

const UploadContent:FC<UploadContentProps> = (props) => {

    const {handleUploadComplete, contentType} = props;

    const uppy = useUppy(() => {
        // @ts-ignore
        return new Uppy({
            autoProceed: true,
            id: 'uppy1',
            debug: true,
            restrictions:{
                allowedFileTypes:contentType
            }
        })
    })

    useEffect(()=>{
        uppy.use(AwsS3Multipart, {
            limit: 4,
            companionUrl: FILE_UPLOAD_BASE_URL
        })

        uppy.on('complete', (result:any) => {
            handleUploadComplete(result)
        })

    },[])

    return (
        <div>
            <div className='content-form__file-upload-button'>
                <img src={uploadIcon} alt=''/>
                <div>Upload file</div>
                <FileInput
                    uppy={uppy}
                    pretty={true}
                    inputName='files[]'
                />
            </div>
            <StatusBar
                uppy={uppy}
                hideUploadButton
                hideAfterFinish={false}
                showProgressDetails
            />
        </div>
    )
}

export default UploadContent;
